module.exports = __webpack_public_path__ + "img/6.4254b80b.svg";